<script>
export default {
  data () {
    return {
      show: false
    }
  },
  created () {
    const vm = this
    vm.$bus.$on('Loading', data => {
      vm.StratLoading(data)
    })
  },
  methods: {
    StratLoading (data) {
      const vm = this
      vm.show = data
      // 定義時間，30秒後show 變為false
      vm.Loadingdate()
    },
    Loadingdate () {
      const vm = this
      var timeoutID = setTimeout(() => {
        vm.show = false
      }, 30000)
      if (!vm.show) {
        window.clearTimeout(timeoutID)
      }
    }
  }
}
</script>

<template>
  <div
    id="loading"
    class="no-print"
    v-if="show"
  >
    <div style="position: relative; top: 50%;">
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border text-warning"
          style="width: 5rem; height: 5rem;"
          role="status"
        >
          <span class="sr-only">
            載入中...
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  #loading {
    display: block;
    z-index: 9999;
    height: 100%;
    width: 100%;
    position: fixed;
    background-color: rgba(248, 248, 248, 0.63);
  }

</style>
